import ModalWorkFlowProvider, { useModalWorkFlow } from "@/contexts/ModalWorkFlowProvider";
import BackArrow from "@/images/BackArrow";
import Modal from "@/tpo/Modal";
import { ActionIcon } from "@/v2/Buttons";

function View({ children, index }) {
  const { view } = useModalWorkFlow();
  return index === view ? children : null;
}

function ModalWorkFlowInternal({ children, ...props }) {
  const { defaultView, view, setView } = useModalWorkFlow();

  const backArrowIcon = (
    <ActionIcon
      color="dark"
      height={[40, 40, 48]}
      width={[40, 40, 48]}
      borderRadius="50%"
      onClick={() => {
        setView(defaultView);
      }}
      variant="outline"
      style={{
        pointerEvents: "auto"
      }}
      size={null}
    >
      <BackArrow color="black" />
    </ActionIcon>
  );

  return (
    <Modal title={view === defaultView ? null : backArrowIcon} {...props}>
      {children}
    </Modal>
  );
}

function ModalWorkFlow({ children, defaultView = 1, ...props }) {
  return (
    <ModalWorkFlowProvider defaultView={defaultView}>
      <ModalWorkFlowInternal {...props}>{children}</ModalWorkFlowInternal>
    </ModalWorkFlowProvider>
  );
}

ModalWorkFlow.View = View;

export default ModalWorkFlow;
